module.exports = __webpack_public_path__ + "static/digital-titan-mag-306661215e0772c961e06d29c36b1878.jpg";